<template >


	<section>
	     <!-- Content Header (Page header) -->
	     <section class="content-header">
	        <h1>
	           EDITAR PAPELETA
	           <small>Percy</small>
	        </h1>
	        <ol class="breadcrumb">
	           <li><a href="#"><i class="fa fa-dashboard"></i> Home</a></li>
	           <li class="active">Ver Papeleta</li>
	        </ol>
	     </section>
	     <!-- Main content -->
	     <section class="content">
	        <div class="row">
	        <!-- left column -->
	          <div class="col-md-12">
	             <!-- general form elements -->
	             <div class="box box-primary">

	             	<div class="box-header with-border">
		               <h3 class="box-title">Detalle:</h3>
		            </div>

	                <!-- /.box-header -->
	                <!-- form start -->
            		<div class="row">	

                      	<div class="col-md-12">
                        	

                        	<div class="col-md-12">
	                           <div class="form-group">
	                              <label>Subir papeleta.</label>
	                              <input type="text"  class="form-control"  placeholder="Company" value="Creative Code Inc.">
	                           </div>
	                        </div>


	                        <div class="col-md-12">
	                        	
	                        	<div class="form-group">
	                        		
	                        		<input type="hidden" name="id">
	                        		<button class="btn btn-light" type="submit">Enviar</button>
	                        	</div>
	                        </div>
	                         <!--

	                          <button class="btn btn-light">
	                           <i class="fa fa-trash"> Eliminar</i>
	                         </button>
	                      -->

                      	</div>
            		</div>


	                <br>



	             </div>
	             <!-- /.box -->
	          </div>
	        
	      </div>
     </section>
  </section>


</template>

<script>
export default {

  name  :  'PapeletasSubir',
  data(){
    return {

    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/PapeletasSubir.vue